<template>
    <div>
        <div class="dragAreaContainerFront">
            <div class="dragArea" ref="dragArea" @dragover="dragoverfront" @drop="dropFront">
                <div class="dragAreaContent">
                    <div class="dragMessage">
                        <img class = "uploadImage" src = "/img/upload-cloud.svg">
                        <p class = "dragText">
                            Drag and drop files here
                        </p>
                        <p class = "imageText">
                            Upload aadhaar front
                        </p>
                        <p class = "imageText">
                            *Single page aadhaar pdf can be uploaded as well
                        </p>
                    </div>
                    <label for="file-upload-front" class="fileUploadButton">
                        <input
                            type="file"
                            name="file-upload-front"
                            id="file-upload-front"
                            class="inputField"
                            @change="onChangeFront($event)"
                            accept=".pdf,.jpg,.jpeg,.png"
                        />
                        Browse Files
                    </label>
                </div>
                <ul class="mt-4" v-if="this.frontAadhaarImage" v-cloak>
                        {{ frontAadhaarImage.name }}
                        <v-icon @click="removeFront(frontAadhaarImage)" title="Remove file">
                            fas fa-times-circle
                        </v-icon>
                </ul>
            </div>
        </div>
        <div class="dragAreaContainer">
            <div class="dragAreaBack" ref="dragArea" @dragover.prevent="dragoverback" @drop.prevent="dropBack">
                <div class="dragAreaContent">
                    <div class="dragMessage">
                        <img class = "uploadImage" src = "/img/upload-cloud.svg">
                        <p class = "dragText">
                            Drag and drop files here
                        </p>
                        <p class = "imageText">
                            Upload aadhaar back
                        </p>
                    </div>
                    <label for="file-upload-back" class="fileUploadButton">
                        <input
                            type="file"
                            multiple
                            name="file-upload-back"
                            id="file-upload-back"
                            class="inputField"
                            @change="onChangeBack($event)"
                            accept=".pdf,.jpg,.jpeg,.png"
                        />
                        Browse Files
                    </label>
                </div>
                <ul class="mt-4" v-if="this.backAadhaarImage" v-cloak>
                        {{ backAadhaarImage.name }}
                        <v-icon @click="removeBack(backAadhaarImage)" title="Remove file">
                            fas fa-times-circle
                        </v-icon>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            frontAadhaarImage: null,
            backAadhaarImage: null
        }
    },
    methods: {
        onChangeFront (e) {
            if (this.frontAadhaarImage != null) {
                this.removeFront()
            }
            this.frontAadhaarImage = e.target.files[0] || e.dataTransfer.files[0]
            this.$emit('filesSelected', this.frontAadhaarImage)
        },
        onChangeBack (e) {
            if (this.backAadhaarImage != null) {
                this.removeFront()
            }
            this.backAadhaarImage = e.target.files[0] || e.dataTransfer.files[0]
            this.$emit('filesSelected', this.backAadhaarImage)
        },
        removeFront () {
            this.$emit('removeFile', this.frontAadhaarImage)
            this.frontAadhaarImage = null
        },
        removeBack () {
            this.$emit('removeFile', this.backAadhaarImage)
            this.backAadhaarImage = null
        },
        dragoverfront (event) {
            event.preventDefault()
        },
        dragoverback (event) {
            event.preventDefault()
        },
        dropFront (event) {
            event.preventDefault()
            if (this.frontAadhaarImage != null) {
                this.removeFront()
            }
            const file = event.dataTransfer.files
            this.frontAadhaarImage = file[0]
            this.$emit('filesSelected', this.frontAadhaarImage)
        },
        dropBack (event) {
            if (this.backAadhaarImage != null) {
                this.removeFront()
            }
            event.preventDefault()
            const file = event.dataTransfer.files
            this.backAadhaarImage = file[0]
            this.$emit('filesSelected', this.backAadhaarImage)
        }
    }
}
</script>

<style lang="scss" scoped>
.dragAreaContainerFront {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 10px
}
.dragAreaContainer {
    display: flex;
    align-items: center;
    justify-content: center;
}
.dragAreaBack {
    height: 160px;
    width: 335px;
    border-width: 1px;
    border: 1px solid #E0E0E0;
    border-radius: 12px;

    .dragAreaContent {
        display: flex;
        flex-direction: column;
        align-items: center;

        .fileUploadButton {
            color: #002FA7;
            font-weight: 600px;
            font-size: 13px;
            padding-top: 5px;
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .dragMessage {
        display: flex;
        flex-direction: column;

        .v-icon.v-icon {
            font-size: 48px;
        }
    }

    ul {
        list-style-type: none;
        margin-top: 0px !important;

        li {
            display: flex;
            justify-content: space-between;
            padding: 4px;
        }
    }
}
.dragArea {
    height: 190px;
    width: 335px;
    border-width: 1px;
    border: 1px solid #E0E0E0;
    border-radius: 12px;

    .dragAreaContent {
        display: flex;
        flex-direction: column;
        align-items: center;

        .fileUploadButton {
            color: #002FA7;
            font-weight: 600px;
            font-size: 13px;
            padding-top: 5px;
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .dragMessage {
        display: flex;
        flex-direction: column;

        .v-icon.v-icon {
            font-size: 48px;
        }
    }

    ul {
        list-style-type: none;
        margin-top: 6px !important;

        li {
            display: flex;
            justify-content: space-between;
            padding: 4px;
        }
    }
}

.inputField {
    width: 1px;
    position: absolute;
    overflow: hidden;
    opacity: 0;
    height: 1px;
}

.bg-green-300 {
    background: #f1e9c6;
}

.bg-gray-100 {
    background: #E5E5E5;
}
.uploadImage {
    padding-bottom: 5px;
    height: 50px;
}
.dragText {
    text-align: center;
    color: #232323;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 2px !important;
}
.imageText {
    color: #9e9e9e;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 2px !important;
}
</style>
